// Centralised renderers for loading / error / unsupported screens.
//
// We keep these structurally identical (single card layout) so that switching
// between them produces a stable visual frame and the customer doesn't see a
// jarring layout shift.

export function renderLoading(): HTMLElement {
  const el = document.createElement("section");
  el.className = "dm-state dm-state--loading";
  el.setAttribute("data-testid", "dm-loading");
  el.innerHTML = `
    <div class="dm-spinner" aria-hidden="true"></div>
    <p class="dm-state__title">Loading your deck preview…</p>
  `;
  return el;
}

export function renderError(title: string, detail: string): HTMLElement {
  const el = document.createElement("section");
  el.className = "dm-state dm-state--error";
  el.setAttribute("data-testid", "dm-error");
  const h = document.createElement("h2");
  h.className = "dm-state__title";
  h.textContent = title;
  const p = document.createElement("p");
  p.className = "dm-state__detail";
  p.textContent = detail;
  el.append(h, p);
  return el;
}

export function renderExpired(): HTMLElement {
  const el = renderError(
    "This link has expired or was revoked",
    "Ask your contractor to send you a fresh preview link.",
  );
  el.setAttribute("data-testid", "dm-expired");
  return el;
}

export function renderNotFound(): HTMLElement {
  const el = renderError(
    "Preview not found",
    "Double-check the link you were sent, or ask your contractor to resend it.",
  );
  el.setAttribute("data-testid", "dm-not-found");
  return el;
}
